import Handlebars from "handlebars"
import el from "./elements"

class tables {

	constructor() {
		this.container = document.getElementById('data-view')
	}

	table(json){
		if(this.container){
			el.empty(this.container)
		
			if(json.header){

				const info = el.build('div', '', ['px-4','pb-4','d-flex'])
				el.add(info, [this.search(json.search), this.info(json)])

				const tb = el.build('table', '', ['table', 'ocp-table'])
				this.columns(tb, json.header)
				this.lines(tb, json)

				el.add(this.container, [info, tb])
			}else{
				const aplsrc = el.build('p', 'Aplique o Filtro para Realizar a Consulta', ['text-center', 'small', 'text-secondary'])
				el.add(aplsrc, [el.build('i', '', ['bi', 'bi-search', 'ms-2'])])
				this.container.appendChild(aplsrc)
			}
		}
	}

	search(json){
		const div = el.build('div', '')
		if(json){
			for(let item in json){
				el.add(div, [el.build('span', `${item}: ${json[item]}`, ['me-2','badge', 'custom-badge', 'rounded-pill'])])
			}
		}

		return div;
	}

	info(json){
		if(json.header){
			const total = (json.body || {}).length;
			const strTotal = `${total} ${(total > 1) ? " Registros Localizados" : " Registro Localizado"}` 

			const inf = el.build('div', '', ['ms-auto', 'text-end', 'ocp-table-info'])
			const icon = el.build('i', '', ['bi', 'bi-grip-vertical'])
			const span = el.build('span', strTotal)
		
			el.add(inf, [icon, span])

			return inf;
		}
		return null;
	}

	columns(table, json){
		if(table && json){
			const head = table.createTHead()
			const line = el.build('tr', '',  ['ocp-table-th'])
			for (let item in json) {
				el.add(line, [el.build('th', json[item].title)])
			}
			head.appendChild(line)
		}
	}

	lines(table, json){
		if(json.header && json.body){
			
			const body = table.createTBody()

			json.body.forEach(l => {
				const line = el.build('tr', '',  ['ocp-table-tr'])
				for(let i in json.header){
					line.appendChild(this.values(i, json.header, l))
				}
				body.appendChild(line)
			});
		}
	}

	values(i, col, line){

		function logo(path){
			const td = el.build('td', '')
			el.add(td, [el.build('img', '', ['table-img'], {'src':'uploads/'+path, 'alt':'imagem-logo'})])
			return td
		}

		function getvalues(i, col, line){
			if(typeof(line[i]) === 'object' && line[i] !== null){
				const td = el.build('td')
				let props = col[i].props.split('.')
				props.forEach(prop => {
					el.add(td, [el.build('p', line[i][prop], ['p-table'])])
				})
				
				return td
			}

			return el.build('td', line[i])
		}

		function actions(col, line){
			if(col && line){
				const td = el.build('td', '', ['text-end', 'text-truncate'])
				const configs = {
					"delete": {
						"class": ['btn-danger-hover', 'bi-trash3'],
						"attrs": {"data-bs-toggle":"modal", "data-bs-target":"#modalDelete", "data-bs-title":"Excluir"}
					},
					"edit":{
						"class": ['btn-primary-hover', 'bi-pencil'],
						"attrs": {"data-bs-toggle":"modal", "data-bs-target":"#modalRegister", "data-bs-title":"Editar"}
					},
					"open":{
						"class": ['btn-primary-hover', 'bi-arrow-right-circle'],
						"attrs": {"data-bs-title":"Abrir"}
					},
					"report":{
						"class": ['btn-primary-hover', 'bi-file-medical'],
						"attrs": {"data-bs-title":"Relatório"}
					},
					"view":{
						"class": ['btn-primary-hover', 'bi-eye'],
						"attrs": {"data-bs-title":"Visualizar"}
					}
				}

				const defCls = ['btn', 'btn-sm', 'btn-action-tab', 'ms-2', 'bi']
				const defAtr = {"type":"button","data-bs-placement":"top","data-bs-custom-class":"custom-tooltip", }

				const acts = col.actions || {}
				for(let act in acts){

					const dinCls = configs[act].class
					const dinAtr = configs[act].attrs

					const btn = el.build('button', '', dinCls, dinAtr)
					el.setClass(btn, defCls)
					el.setAttrs(btn, defAtr)
	
					//build dinamic attrs
					const dinamicBackEndAttrs = acts[act] || {}
					for(let backEndAttr in dinamicBackEndAttrs){
						const attrValue = Handlebars.compile(dinamicBackEndAttrs[backEndAttr])
						btn.setAttribute(backEndAttr, attrValue(line))
					}

					td.appendChild(btn)

					new bootstrap.Tooltip(btn)
				
				}
	
				return td
			}
	
			return null;
		}

		switch (i) {
			case 'logo':
				return logo(line[i])

			case 'actions':
				return actions(col, line)
		
			default:
				return getvalues(i, col, line)
		}
	}
}

export default new tables()
